// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyStatePlaceholder_wrapper__hZHws","message":"EmptyStatePlaceholder_message__6TUPM"};